import { uniqueId } from 'lodash';
import {
  ProjectTimeEntry,
  ProjectWithStatus,
} from '../../../../Projects/types';
import { TimeEntryData } from './types';
import { UNIQUE_ID_PREFFIX, minToHoursInput } from './utils';

export function mapToFormData({
  id,
  projectId,
  costCenterId,
  notes,
  minutes,
  extraFields,
  recordTypeName,
  timeEntryId,
}: ProjectTimeEntry): TimeEntryData {
  return {
    id: id,
    projectId,
    costCenterId,
    notes: notes || '',
    hours: minutes ? minToHoursInput(minutes) : null,
    extraFields,
    recordTypeName,
    timeEntryId,
  };
}

export function mapToProjectTimeEntry({
  id,
  projectId,
  costCenterId,
  notes,
  hours,
  extraFields,
  recordTypeName,
  timeEntryId,
}: TimeEntryData): ProjectTimeEntry | null {
  if (!hours || !projectId) {
    return null;
  }

  return {
    id,
    timeEntryId,
    notes,
    projectId,
    costCenterId,
    minutes: Math.round(hours * 60),
    extraFields,
    recordTypeName,
  };
}

export function getActiveProjectId(projects: ProjectWithStatus[]) {
  const project = projects.find((project) => project.status === 'ACTIVE');
  return project ? project.id : null;
}

export function createEmptyItem(
  projectId: string | null,
  defaultRecordTypeName: string | null,
  initialHours?: number,
  timeEntryId?: string | null,
): TimeEntryData {
  return {
    id: uniqueId(`${UNIQUE_ID_PREFFIX}_${Date.now()}`),
    timeEntryId: timeEntryId ?? null,
    notes: '',
    hours: initialHours ?? 1,
    projectId,
    costCenterId: null,
    extraFields: [],
    recordTypeName: defaultRecordTypeName,
  };
}
